export default __webpack_public_path__ + "static/media/skill-upgradation.4248c90d.jpg";